// extracted by mini-css-extract-plugin
module.exports = {"indicators":"BannerLayout_indicators__Hx8ev","indicator":"BannerLayout_indicator__qxc5h"};